export const BRAND_NAME = 'King Edwards Academy';
export const EMAIL_CONTACT = 'support@kingedwardsacademy.net';
export const TEL_CONTACT = '+263 77 461 9684'
export const BRAND_HEADLINE = 'Dedicated to Excellence'
export const META_CONTENT = 'Cambridge and ZIMSEC Curricula in Zimbabwe'
export const PRICING_URL = 'www.kingedwardsacademy.net/pricing'

// Official social media accounts. Leave a value empty and the link/icon is
// hidden across the site, so we never point visitors at a page that is not ours.
export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/profile.php?id=61574452679320',
  instagram: '',
  tiktok: '',
  twitter: ''
}
